import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Radio, Menu, X } from "lucide-react";
import { STATION } from "../mock";
import { usePlayer } from "../context/PlayerContext";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/programmas", label: "Programma's" },
  { to: "/playlist", label: "Playlist" },
  { to: "/geschiedenis", label: "Geschiedenis" },
  { to: "/luisterlinks", label: "Luisterlinks" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { togglePlay, isPlaying } = usePlayer();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-[#3E8CF5]/85 backdrop-blur-xl border-b border-white/15 shadow-sm" : "bg-transparent"}`}>
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between px-5 sm:px-8">
        <Link to="/" className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-[#1E6BE6] to-[#2E7DF7] shadow-lg shadow-blue-900/20 ring-1 ring-white/30">
            <img src={STATION.logo} alt="All-In Radio" className="h-full w-full object-contain p-2" />
          </span>
          <span className="font-heading text-lg font-extrabold tracking-tight text-white">All-In Radio</span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className="relative text-sm font-semibold transition-colors text-white/85 hover:text-white">
              {({ isActive }) => (
                <span className={`relative ${isActive ? "text-white" : ""}`}>
                  {n.label}
                  {isActive && <span className="absolute -bottom-2 left-0 h-0.5 w-full rounded-full bg-white" />}
                </span>
              )}
            </NavLink>
          ))}
          <button
            onClick={togglePlay}
            className="flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#1E6BE6] shadow-lg shadow-blue-900/10 transition-transform hover:scale-105"
          >
            <Radio className="h-4 w-4" />
            {isPlaying ? "Live" : "Luister live"}
          </button>
        </nav>

        <button className="md:hidden text-white" onClick={() => setOpen((o) => !o)} aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#3E8CF5]/95 backdrop-blur-xl border-t border-white/15 px-5 py-4">
          <div className="flex flex-col gap-2">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className={({ isActive }) => `rounded-lg px-3 py-2 text-sm font-semibold ${isActive ? "bg-white/20 text-white" : "text-white/85"}`}>
                {n.label}
              </NavLink>
            ))}
            <button onClick={() => { togglePlay(); setOpen(false); }} className="mt-1 flex items-center justify-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#1E6BE6]">
              <Radio className="h-4 w-4" /> Luister live
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
